import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './voltar.module.scss';
import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const Voltar = ({ action}) => {
    const history = useHistory()
    return (
            <div className={styles.backButton} onClick={() => {history.goBack()}}>
            <IconButton aria-label="close" className="backModal"><ArrowBack /></IconButton>
            </div>
    )
}

export default Voltar;